import { NavLink, useLocation } from 'react-router-dom';
import logo from '../assets/images/hf-logo.png';
import { buildLocalizedPath, content, getLangFromPath } from '../i18n';

function Header() {
  const location = useLocation();
  const lang = getLangFromPath(location.pathname);
  const t = content[lang];

  const homePath = lang === 'en' ? '/en' : '/';
  const contactPath = lang === 'en' ? '/en/contact' : '/contact';

  const switchToEN = buildLocalizedPath(location.pathname, 'en');
  const switchToGR = buildLocalizedPath(location.pathname, 'gr');

  return (
    <header className="topbar">
      <div className="container topbar-inner">
        <NavLink to={homePath} className="brand">
          <img src={logo} alt="Green Your Freight" className="brand-logo" />
        </NavLink>

        <div className="topbar-center">
          <div className="language-switcher">
            <NavLink
              to={switchToEN}
              className={`lang-btn ${lang === 'en' ? 'active-lang' : ''}`}
              aria-label="Switch to English"
              title="English"
            >
              <span>🇬🇧</span>
              <span>EN</span>
            </NavLink>

            <NavLink
              to={switchToGR}
              className={`lang-btn ${lang === 'gr' ? 'active-lang' : ''}`}
              aria-label="Μετάβαση στα Ελληνικά"
              title="Ελληνικά"
            >
              <span>🇬🇷</span>
              <span>GR</span>
            </NavLink>
          </div>
        </div>

        <nav className="main-nav">
          <NavLink
            to={homePath}
            className={({ isActive }) => (isActive ? 'nav-link active' : 'nav-link')}
          >
            {t.header.home}
          </NavLink>

          <a
            href="https://app.greenyourfreight.eu"
            target="_blank"
            rel="noreferrer"
            className="nav-link nav-link-cta"
          >
            {t.header.enterApp}
          </a>

          <NavLink
            to={contactPath}
            className={({ isActive }) => (isActive ? 'nav-link active' : 'nav-link')}
          >
            {t.header.contact}
          </NavLink>
        </nav>
      </div>
    </header>
  );
}

export default Header;